module.exports = __webpack_public_path__ + "img/25.4ec6e5cb.png";